import InfoOutlineIcon from '@rsuite/icons/InfoOutline';
import CloseIcon from '@rsuite/icons/Close';
import { useEffect, useState } from 'react';
import {
  Button,
  ButtonToolbar,
  Drawer,
  IconButton,
  Stack,
  useToaster
} from 'rsuite';
import {
  formatQueryRes,
  regionApi,
  useAppDispatch,
  useAppSelector,
  useGetHaInstanceExtraInfoQuery,
  useResizeMutation
} from '@monorepo/shared';
import { selectCurrentAccount } from '@monorepo/shared/store/accountSlice';
import { ErrorToaster } from './InstanceStatus';
import { Icon } from '@rsuite/icons';
import React from 'react';
interface IProps {
  instance: Record<string, any>;
}
export const TrialActive = ({ instance }: IProps) => {
  const currentAccount = useAppSelector(selectCurrentAccount);
  const [open, setOpen] = useState<boolean>(false);
  const [isResizeFailed, setIsResizeFailed] = useState<boolean>(false);
  const [instanceResize, resizeResult] = useResizeMutation();
  const toaster = useToaster();
  const dispatch = useAppDispatch();

  const {
    data: instanceExtraInfo,
    isLoading: instanceExtraInfoLoading,
    isFetching: instanceExtraInfoFetching
  } = useGetHaInstanceExtraInfoQuery(
    formatQueryRes({
      account: currentAccount,
      instance_id: instance?.instance_id,
      region: instance?.region
    }),
    { skip: !instance?.region?.token }
  );

  const goToActive = (id: string) => {
    setOpen(true);
  };

  const onConfirm = () => {
    instanceResize({
      account_id: currentAccount.account_id,
      user_id: currentAccount.user_id,
      access_from_user_id:
        currentAccount.access_from_user_id ||
        currentAccount.access_from?.user_id,
      instance_id: instance?.instance_id,
      region: instance?.region,
      eta_mins: 0
    });
  };
  useEffect(() => {
    if (instance?.resize_status === 'RESIZE_ERROR') {
      setIsResizeFailed(true);
    }
  }, [instance]);

  useEffect(() => {
    if (resizeResult.error) {
      const data: Record<string, any> = resizeResult.error;
      const code = data?.error_code || data?.status;
      const messageText =
        data?.error_desc || data?.message || 'Submit Resize Failed!';
      if (messageText) {
        ErrorToaster({
          toaster,
          error: resizeResult.error,
          title: 'Active Trial to Enterprise Failed!'
        });
      }
    } else if (resizeResult.data) {
      if (resizeResult.data?.state === 'RESIZE_ERROR') {
        ErrorToaster({
          toaster,
          error: resizeResult.data?.state,
          title: 'Active Trial to Enterprise Failed!'
        });
        setIsResizeFailed(true);
      }
      dispatch(regionApi.util.invalidateTags(['RegionInstance']));
    }
    setOpen(false);
  }, [resizeResult]);

  return (
    <div
      style={{
        height: '48px',
        boxSizing: 'border-box',
        padding: '0 20px',
        backgroundColor: '#FEF3E4',
        borderLeft: '2px #B28501 solid',
        width: '100%',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '12px'
      }}
    >
      <Stack spacing={14} alignItems="center">
        <InfoOutlineIcon color="#B28501" />
        <span style={{ color: '#48556F' }}>
          {isResizeFailed
            ? 'Activate Enterprise Failed, please contact support'
            : 'Note: Enterprise edition is available for you'}
        </span>
      </Stack>

      {!isResizeFailed && (
        <Button
          appearance="primary"
          size="xs"
          style={{ justifySelf: 'flex-end' }}
          onClick={() => goToActive(instance?.instance_id)}
        >
          Activate Enterprise
        </Button>
      )}
      <Drawer
        backdrop="static"
        open={open}
        onClose={() => setOpen(false)}
        size={'md'}
      >
        <Drawer.Header
          style={{
            padding: '6px 20px',
            backgroundColor: '#F6F9FD',
            display: 'flex',
            alignItems: 'center'
          }}
          closeButton={false}
        >
          <Drawer.Title style={{ color: '#48556F', fontWeight: 'bold' }}>
            {'Activate Enterprise Edition'}
          </Drawer.Title>
          <IconButton
            startIcon={
              <CloseIcon style={{ fontSize: '1.2em', cursor: 'pointer' }} />
            }
            onClick={() => setOpen(false)}
          />
        </Drawer.Header>
        {/* <Drawer.Body classPrefix="trial-upgrade"> */}
        <Drawer.Body className="trial-upgrade-drawer-body">
          {/* <TrialResize /> */}
          <div style={{ color: '#48556F', margin: '20px 0' }}>
            {'Click "Upgrade Now" to upgrade to FortiTIP Enterprise Edition.'}
          </div>
          <div
            style={{
              color: '#48556F',
              marginBottom: '20px'
            }}
          >
            {/* {`Note: The upgrade will take approximately ${
              instanceExtraInfo?.resize?.estimated_cost_time || 1
            } minute(s). During this time your FortiTIP instance will not be available.`} */}
            {
              'Note: The upgrade process may take some time, during which your FortiTIP instance will be temporarily unavailable.'
            }
          </div>
          <ButtonToolbar>
            <Button appearance="primary" onClick={() => onConfirm()}>
              Upgrade Now
            </Button>
            <Button appearance="ghost" onClick={() => setOpen(false)}>
              Later
            </Button>
          </ButtonToolbar>
        </Drawer.Body>
      </Drawer>
    </div>
  );
};

export const TrialResize = () => {
  return (
    <>
      <Stack
        direction="column"
        alignItems="flex-start"
        spacing={24}
        style={{ color: '#48556F' }}
      >
        <div>
          You are eligible for a enterprise edition. Please upgrade to boost and
          Experience the full suite of features and tools of FortiTIP
        </div>
        <div>Once upgrade happens you will get following Feature</div>
        <Stack spacing={16} alignItems="flex-start">
          <ShieldImage />
          <div>
            <div style={{ fontSize: '1.1em' }}>Access to Advanced Feature</div>
            <div>
              Real-time changes detection with granular change data tracks
            </div>
          </div>
        </Stack>
        <Stack spacing={16} alignItems="flex-start">
          <ShieldImage />
          <div>
            <div style={{ fontSize: '1.1em' }}>
              Experience the best output quality
            </div>
            <div>
              Scale as you need with the freedom to integrate diverse products
            </div>
          </div>
        </Stack>
        <Stack spacing={16} alignItems="flex-start">
          <ShieldImage />
          <div>
            <div style={{ fontSize: '1.1em' }}>
              Unlimited access to Standard features
            </div>
            <div>
              Access hundreds of pre-configured content packs and out-of-the-box
              integrations to automate threat detection adn response processes
            </div>
          </div>
        </Stack>
      </Stack>
    </>
  );
};

const ShieldIcon = React.forwardRef((props, ref: any) => (
  <svg {...props} width="24" height="24" viewBox="0 0 24 24" ref={ref}>
    <path
      d="M5.63961 6.81055L11.6875 4.40967L17.7385 6.81055C17.7701 8.2124 17.5211 10.2556 16.6733 12.2504C15.7814 14.3419 14.2434 16.3625 11.6875 17.5613C9.13157 16.3657 7.59359 14.3451 6.70485 12.2504C5.85707 10.2556 5.6081 8.2124 5.63961 6.81055ZM19.2355 6.3916L19.1977 5.73096L18.5926 5.48926L12.0531 2.89502L11.6875 2.75L11.3219 2.89502L4.78238 5.48926L4.18043 5.73096L4.14261 6.3916C4.05121 7.99971 4.29704 10.4618 5.31815 12.8659C6.34872 15.2894 8.18609 17.6999 11.2872 19.0728L11.6875 19.25L12.0878 19.0728C15.1889 17.6999 17.0263 15.2926 18.0568 12.8659C19.078 10.4586 19.3238 7.99971 19.2324 6.3916H19.2355ZM15.2488 9.48535L15.7846 8.9375L14.713 7.84502L14.1773 8.39287L10.679 11.97L9.19775 10.4554L8.66198 9.90752L7.59359 11L8.12936 11.5479L10.1464 13.6104L10.6821 14.1582L11.2179 13.6104L15.2488 9.48535Z"
      fill="#25C7D4"
    />
  </svg>
));

const ShieldImage = () => {
  return (
    <>
      <div
        style={{
          width: '40px',
          height: '40px',
          display: 'grid',
          placeItems: 'center',
          border: '1px solid #E1E3E5',
          borderRadius: '2px',
          backgroundColor: '#F6F9FD'
        }}
      >
        <Icon
          as={ShieldIcon}
          style={{
            width: '2.1em',
            height: '2.1em'
          }}
        />
      </div>
    </>
  );
};
